import {
  ClinicalBasedStudyExecutionOverviewQuery_study_StudyNode_sampleSummary_SampleSummaryNode as SampleSummaryNode,
  ClinicalBasedStudyExecutionOverviewQuery_study_StudyNode_sampleSummary_SampleSummaryNode_sampleDefinitionSummaries_SampleDefinitionSummaryNode_testOrderSummaries_TestOrderSummaryNode as SampleDefinitionTestOrderSummaryNode,
  ClinicalBasedStudyExecutionOverviewQuery_study_StudyNode_sampleSummary_SampleSummaryNode_sampleDefinitionSummaries_SampleDefinitionSummaryNode_testOrderSummaries_TestOrderSummaryNode_procedure as ProcedureOrInaccessibleInfoNode,
} from './__generated/ClinicalBasedStudyExecutionOverviewQuery';

export interface SampleDefinitionTestOrderSummary {
  assay: ProcedureOrInaccessibleInfoNode;
  resolvedCount: number;
  totalCount: number;
}

export interface SampleDefinitionReceivingSummary {
  receivedCount: number;
  discrepancyCount: number;
  stillTargetedCount: number;
}

export interface SampleDefinitionSummary {
  sampleDefinitionId: string;
  sampleDefinitionLabel: string;
  receiving: SampleDefinitionReceivingSummary;
  testOrderSummaries: Array<SampleDefinitionTestOrderSummary>;
}

export const getSampleDefinitionTestOrderSummaries = (
  testOrderSummaries: Array<SampleDefinitionTestOrderSummaryNode>
): Array<SampleDefinitionTestOrderSummary> =>
  testOrderSummaries.map((testOrderSummaryNode) => ({
    assay: testOrderSummaryNode.procedure,
    resolvedCount: testOrderSummaryNode.resolvedCount,
    totalCount: testOrderSummaryNode.totalCount,
  }));

export const getSampleDefinitionSummaries = (
  sampleSummaryNode: SampleSummaryNode | null
): Array<SampleDefinitionSummary> => {
  if (!sampleSummaryNode) {
    return [];
  }
  const sampleDefinitionSummaryNodes = sampleSummaryNode.sampleDefinitionSummaries;

  return sampleDefinitionSummaryNodes.map((sampleDefinitionSummaryNode) => ({
    sampleDefinitionId: sampleDefinitionSummaryNode.sampleDefinition.id,
    sampleDefinitionLabel: sampleDefinitionSummaryNode.sampleDefinition.label,
    receiving: {
      receivedCount: sampleDefinitionSummaryNode.receivedCount,
      discrepancyCount: sampleDefinitionSummaryNode.discrepancyCount ?? 0,
      stillTargetedCount:
        sampleDefinitionSummaryNode.sampleDefinition.treatmentGroup.targetNumberOfSubjects -
        sampleDefinitionSummaryNode.receivedCount,
    },
    testOrderSummaries: getSampleDefinitionTestOrderSummaries(sampleDefinitionSummaryNode.testOrderSummaries),
  }));
};

export const getUncategorizedSampleDefinitionSummary = (
  sampleSummaryNode: SampleSummaryNode | null
): SampleDefinitionReceivingSummary | null => {
  if (
    !sampleSummaryNode ||
    !sampleSummaryNode.uncategorizedSampleDefinitionSummary ||
    sampleSummaryNode.uncategorizedSampleDefinitionSummary.receivedCount === 0
  ) {
    return null;
  }
  const {receivedCount, discrepancyCount} = sampleSummaryNode.uncategorizedSampleDefinitionSummary;
  return {
    receivedCount,
    discrepancyCount,
    stillTargetedCount: 0,
  };
};
